import axios from "./http.js";
class SearchApi {
  static search() {
    const abortController = new AbortController();
    return {
      async call(params = {}) {
        return axios.get(
          `/v1/Search?${new URLSearchParams(params).toString()}`,
          {
            signal: abortController.signal
          }
        );
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
}
var stdin_default = SearchApi;
export {
  stdin_default as default
};
